module.exports = __webpack_public_path__ + "static/ec812a45.yourlogo.png";